import "core-js/modules/es.object.keys.js";
import { mapState } from 'vuex';
import { request, METHOD } from '@/utils/request';
import { handleHoverColorEnter, handleHoverColorLeave } from '@/pages/design/common/utils';
import { clientNameList } from '@/services/design';
export default {
  name: 'MenuCategory',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      basicParams: {
        clientType: 1,
        langId: 2
      },
      nameList: []
    };
  },
  computed: {},
  created: function created() {
    // let langId = window.localStorage.getItem('langId')
    // this.$store.dispatch('getNameListData', {
    //   clientType: 1,
    //   langId: langId,
    // })
    var cdefaultLangObj = window.localStorage.cdefaultLangObj;
    if (cdefaultLangObj) {
      cdefaultLangObj = JSON.parse(cdefaultLangObj);
      this.basicParams.langId = cdefaultLangObj.langId;
    }
    this.getData();
  },
  methods: {
    handleHoverColorEnter: handleHoverColorEnter,
    handleHoverColorLeave: handleHoverColorLeave,
    handleItemEnter: function handleItemEnter(name, i) {
      this.oldBorderColor = this.$refs[name][i].style.borderBottomColor;
      this.$refs[name][i].style.borderBottomColor = this.formData.hoverTextColor;
      this.handleHoverColorEnter(this, name, this.formData.hoverTextColor, i);
    },
    handleItemLeave: function handleItemLeave(name, i) {
      this.$refs[name][i].style.borderBottomColor = this.oldBorderColor;
      handleHoverColorLeave(this, name, i);
    },
    getData: function getData() {
      var _this = this;
      clientNameList(this.basicParams).then(function (res) {
        return res.data;
      }).then(function (res) {
        _this.nameList = res.data;
      });
    },
    onCategoryItemClick: function onCategoryItemClick() {}
  }
};